import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-rename-modal",
    templateUrl: "./rename-modal.component.html",
    styleUrls: ["./rename-modal.component.scss"],
    standalone: false
})
export class RenameModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RenameModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  ngOnInit(): void {}

  cancel(): void {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(this.data.trim());
  }

  hasRequiredItems() {
    return this.data.trim().length > 0;
  }
}
